import { FC } from 'react'
import { Grid } from '@mui/material'
import { Table, DynamicColumn } from 'src/components/ui'
import { DataLoggerDashboardStatistics } from 'src/api'
import { DataLoggerDashboardColumns } from '../dataLogger'

interface Props {
  dataLoggerStatistics: DataLoggerDashboardStatistics;
}

const columns: DynamicColumn<DataLoggerDashboardStatistics>[] = [
  DataLoggerDashboardColumns.SensorsNumber,
  DataLoggerDashboardColumns.InUseSensorsNumber,
]

export const DataLoggerDashboard: FC<Props> = (props) => {
  const { dataLoggerStatistics } = props
  return (
    <Grid container spacing={2}>
      <Grid item container>
        <Table
          columns={columns}
          data={[dataLoggerStatistics]}
          showFooter={false}
          sx={{ width: '100%' }}
        />
      </Grid>
    </Grid>

  )
}
